import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './EditFamily.css';
import axios from 'axios';
import PageHeader from './PageHeader';
import { AxiosPut } from '../http/Axios';

const EditFamily = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const loggedInAs = sessionStorage.getItem("loggedInAs") || "admin";

  const {
    guid,
    familyEmail,
    childId,
    familyData: initialFamilyData,
  } = location.state || {};

  const [familyData, setFamilyData] = useState({
    email: '',
    familyName: '',
    referredBy: '',
    okayToContactIndicator: '',
    zipCode: '',
    city: '',
  });

  useEffect(() => {
    if (initialFamilyData) {
      setFamilyData({
        email: initialFamilyData.email || familyEmail,
        familyName: initialFamilyData.familyName || '',
        referredBy: initialFamilyData.referredBy || '',
        okayToContactIndicator:
          initialFamilyData.okayToContactIndicator === 'N' ? 'N' : 'Y',
        zipCode: initialFamilyData.zipCode || '',
        city: initialFamilyData.city || '',
      });
    }
  }, [initialFamilyData, familyEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const familyPostData = {
      guid: familyData.guid,
      email: familyData.email,
      familyName: familyData.familyName,
      referredBy: familyData.referredBy,
      okayToContactIndicator: familyData.okayToContactIndicator,
      zipCode: familyData.zipCode,
      city: familyData.city,
      modifiedDate: new Date(),
      modifiedBy: loggedInAs,
    };

    console.log('Submitting data:', familyPostData);

    try {
      const response = await AxiosPut(
        process.env.REACT_APP_ADMIN_SERVICE + `/families/updateByGuid/${guid}`,
        familyPostData
      );
      console.log('Family data updated successfully:', response.data);
      const familyDetailsPath = '/family-details-page';
      navigate(
        `${familyDetailsPath}?guid=${guid}`
      );
    } catch (error) {
      console.error('Error submitting family data:', error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log('Updating:', name, '=>', value);
    setFamilyData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCancel = () => {
    const familyDetailsPath = '/family-details-page';
    navigate(
      `${familyDetailsPath}?guid=${guid}`
    );
  };

  return (
    <div className="dashboard landing-page">
      <PageHeader title={`Edit the ${familyData.familyName} Family`} />

      <main className="page-content">
        <form onSubmit={handleSubmit}>
          <div className="family-section">
            <br />
            <br />
            <div className="family-input-grid">

              <div className="family-input-group">
                <label htmlFor="familyName">
                  Family name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="familyName"
                  value={familyData.familyName}
                  onChange={handleInputChange}
                  required
                  maxLength="31"
                  pattern="[a-zA-Z .'-]+"
                  title="Family name should only contain letters, period, apostrophe, hyphen/dash/em-dash, quotes, and spaces."
                  className="family-input-size"
                />
                {errors.familyName && (
                  <p className="error-message">{errors.familyName}</p>
                )}
              </div>

              <div className="family-input-group">
                <label htmlFor="referredBy">
                  How did you hear about our lab?{' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  name="referredBy"
                  value={familyData.referredBy}
                  onChange={handleInputChange}
                  className="family-input-size"
                >
                  <option value="">Select Reference</option>
                  <option value="Craigslist">Craigslist</option>
                  <option value="LeapFrog Employee">LeapFrog Employee</option>
                  <option value="Friend">Friend</option>
                  <option value="Newspaper Ad">Newspaper Ad</option>
                  <option value="Flyer">Flyer</option>
                  <option value="Berkeley Parents Network">
                    Berkeley Parents Network
                  </option>
                  <option value="Kindercare">Kindercare</option>
                  <option value="Golden Gate Mothers Group">
                    Golden Gate Mothers Group
                  </option>
                  <option value="510 Families">510 Families</option>
                  <option value="East Bay Preschool Fair">
                    East Bay Preschool Fair
                  </option>
                  <option value="Other">Other</option>
                </select>
                {errors.referredBy && (
                  <p className="error-message">{errors.referredBy}</p>
                )}
              </div>

              <div className="family-input-group">
                <label>Okay to contact?</label>
                <select
                  name="okayToContactIndicator"
                  value={familyData.okayToContactIndicator ? 'Y' : 'N'}
                  onChange={handleInputChange}
                  className="family-input-size"
                >
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </div>

              <div className="button-group">
                <button type="submit" className="submit-button">
                  Submit
                </button>
                <button
                  type="button"
                  className="cancel-button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </main>
    </div>
  );
};

export default EditFamily;
